<div class="row page-header">
    <div class="col-12">
        <h1>
            Quality Control
            <small>Manage quality control inspections and records</small>
        </h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <wj-combo-box
                    [(ngModel)]="selectedJob"
                    name="selectedJob"
                    (ngModelChange)="onJobChanged()"
                    style="width: 400px"
                    [itemsSource]="jobMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </form>
        </div>
    </div>
    <div class="row" style="margin-top: 15px" [hidden]="!selectedJob() || selectedJob() === ''">
        <div class="col-12">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
                <!-- Concrete Tab -->
                <li [ngbNavItem]="1" [destroyOnHide]="false">
                    <a ngbNavLink>Concrete</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-concrete
                            #concreteComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-concrete>
                    </ng-template>
                </li>
                <!-- Dirt Tab -->
                <li [ngbNavItem]="2" [destroyOnHide]="false">
                    <a ngbNavLink>Dirt</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-dirt
                            #dirtComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-dirt>
                    </ng-template>
                </li>
                <!-- Pipe Tab -->
                <li [ngbNavItem]="3" [destroyOnHide]="false">
                    <a ngbNavLink>Pipe</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-pipe
                            #pipeComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-pipe>
                    </ng-template>
                </li>
                <!-- Road Tab -->
                <li [ngbNavItem]="4" [destroyOnHide]="false">
                    <a ngbNavLink>Road</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-road
                            #roadComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-road>
                    </ng-template>
                </li>
                <!-- Mechanical Tab -->
                <li [ngbNavItem]="5" [destroyOnHide]="false">
                    <a ngbNavLink>Mechanical</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-mechanical
                            #mechanicalComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-mechanical>
                    </ng-template>
                </li>
                <!-- Painting Tab -->
                <li [ngbNavItem]="6" [destroyOnHide]="false">
                    <a ngbNavLink>Painting</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-painting
                            #paintingComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-painting>
                    </ng-template>
                </li>
                <!-- Cathodic Tab -->
                <li [ngbNavItem]="7" [destroyOnHide]="false">
                    <a ngbNavLink>Cathodic</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-cathodic
                            #cathodicComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-cathodic>
                    </ng-template>
                </li>
                <!-- Concrete Test Results Tab -->
                <li [ngbNavItem]="8" [destroyOnHide]="false">
                    <a ngbNavLink>Concrete Test Results</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-concrete-result
                            #concreteResultComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-concrete-result>
                    </ng-template>
                </li>
                <!-- Soil / Density Results Tab -->
                <li [ngbNavItem]="9" [destroyOnHide]="false">
                    <a ngbNavLink>Soil / Density Results</a>
                    <ng-template ngbNavContent>
                        <app-quality-control-soil-result
                            #soilResultComponent
                            [selectedJob]="selectedJob"
                            [allJobs]="allJobs"
                        ></app-quality-control-soil-result>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
        </div>
    </div>
    <div class="row" style="margin-top: 15px" [hidden]="selectedJob() && selectedJob() !== ''">
        <div class="col-12">
            <p>Please select a project from the dropdown above.</p>
        </div>
    </div>
</div>
